import { atom } from "jotai";
import templatesStorage from "../storages/templatesStorage";

export const templateAtoms = atom(
  (get) => {
    return templatesStorage.templates;
  }
);

export const selectedTemplateIdAtom = atom<string | null>(null);

export const selectedTemplateAtom = atom(
  (get) => {
    const foundTemplate = get(templateAtoms).find((template) => template._id === get(selectedTemplateIdAtom));
    console.log('selectedTemplateAtom', foundTemplate);
    return foundTemplate;
  }
);
